export default "__VITE_ASSET__jc3bXEHJ__"